<!--
 * @Author: lijiahui
 * @Date: 2020-02-24 14:01:44
 * @LastEditTime: 2020-02-24 14:18:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\components\activity\donation_active\phoneOpen.vue
 -->

<template>
    <div class="content">
        <div class="phone"><img src="../../../assets/images/activity/donationActive/phone.png" alt=""></div>
        <div class="text">请在手机端浏览</div>
    </div>
</template>

<style lang="less" scoped>
    .content{
        text-align: center;
        padding-top: 180px;
        .phone{
            padding-bottom: 20px;
        }
        .text{
            font-size: 20px;
            font-weight: 400;
            color: #333;
        }
    }
</style>


<script>
export default {
    
}
</script>
